import {
  LAYER_SPACE,
  LAYER_MINDMAP,
  LAYER_VOLCANO,
  LAYER_CRYSTAL,
  LAYER_DRAWING,
} from "./constants";

export const layers = [
  {
    name: LAYER_SPACE,
    color: "green",
    text: "All things",
  },
  {
    name: LAYER_MINDMAP,
    color: "orange",
    text: "Subterranean Air",
  },
  {
    name: LAYER_VOLCANO,
    color: "red",
    text: "Central Fire",
  },
  {
    name: LAYER_CRYSTAL,
    color: "blue",
    text: "Virgin Earth",
  },
  {
    name: LAYER_DRAWING,
    color: "purple",
    text: "Fiery Water",
  },
];

export const intialLayer = layers[2];
